// extracted by mini-css-extract-plugin
export var blueBanner = "signup-module--blueBanner--AMqrk";
export var container = "signup-module--container--KZYhn";
export var header = "signup-module--header--HPQ8A";
export var main = "signup-module--main--BxBB-";
export var mainPadding = "signup-module--mainPadding--jnOWq";
export var mainRaised = "signup-module--mainRaised--QvRz6";
export var space100 = "signup-module--space100--illsy";
export var space150 = "signup-module--space150--h4Jt-";
export var statement = "signup-module--statement--rZT2z";